import React from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

// Components
import CustomerReportDownloadsHeader from "./CustomerReportDownloadsHeader";
import CustomerReportDownloadsBody from "./CustomerReportDownloadsBody";

// This component will hold the latest leads data
const CustomerReportDownloadsTable = ({ reportDownloads, open }) => {
  return (
    <div className={`${open ? "show-table" : "hide-table"}`}>
      <TableContainer>
        <Table className="table">
          <CustomerReportDownloadsHeader />
          <CustomerReportDownloadsBody 
            reportDownloads={reportDownloads}
           />
        </Table>
      </TableContainer>
      <div className="bottom-footer"></div>
    </div>
  );
};

export default CustomerReportDownloadsTable;
